import * as React from 'react';
import { SVGProps } from 'react';

const IconTieSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15.5 0h-7l2.35 4.272L7.5 20l4.5 4 4.5-4-3.35-15.728L15.5 0z" />
  </svg>
);
export default IconTieSizeM;
